import type React from "react";
import commonHeaderStyles from "~/components/Document/commonDocumentHeader/index.module.scss";
import SystemProposalDisplay from "~/components/Document/SystemProposalDisplay";
import { CommonButton } from "~/components/ui/commonButton";
import { TutorialTooltip } from "~/components/ui/tutorialTooltip";
import { sampleSystemProposalData } from "~/data/sampleProject";
import { useTutorialAccessGuard } from "~/hooks/useTutorialAccessGuard";
import EditWhite from "~/images/edit_white.svg?react";
import ExportPrimary from "~/images/export_primary.svg?react";
import styles from "./index.module.scss";

const TutorialSystemProposal: React.FC = () => {
  useTutorialAccessGuard();

  const sampleDocument = {
    id: "tutorial-system-proposal-001",
    name: "システム概要書",
    type: "system-proposal",
    content: JSON.stringify(sampleSystemProposalData),
    created_at: "2024-01-15T10:00:00Z",
    modified_at: "2024-01-15T11:30:00Z",
    created_by: {
      id: "tutorial-user",
      first_name: "チュートリアル",
      last_name: "ユーザー",
      display_name: "チュートリアルユーザー",
      email: "tutorial@example.com",
      organization_id: "tutorial-org",
    },
    modified_by: {
      id: "tutorial-user",
      first_name: "チュートリアル",
      last_name: "ユーザー",
      display_name: "チュートリアルユーザー",
      email: "tutorial@example.com",
      organization_id: "tutorial-org",
    },
  };

  return (
    <div className={styles["wrapper"]} data-tour-id="system-proposal-content">
      <div className={commonHeaderStyles["commonDocumentHeader"]}>
        <div className={commonHeaderStyles["commonDocumentHeader-inner"]}>
          <div className={commonHeaderStyles["commonDocumentHeader-left"]}>
            <h1>{sampleDocument.name}</h1>
          </div>
          <div className={commonHeaderStyles["commonDocumentHeader-right"]}>
            <div className={commonHeaderStyles["commonDocumentHeader-buttons"]}>
              <TutorialTooltip message="生成されたドキュメントを編集できます" position="bottom">
                <CommonButton icon={<EditWhite />} onClick={() => {}}>
                  編集
                </CommonButton>
              </TutorialTooltip>
              <TutorialTooltip message="さまざまな形式でエクスポートできます" position="bottom">
                <CommonButton icon={<ExportPrimary />} variant="icon" onClick={() => {}} />
              </TutorialTooltip>
            </div>
          </div>
        </div>
      </div>

      <SystemProposalDisplay data={sampleSystemProposalData} noWrapper />
    </div>
  );
};

export default TutorialSystemProposal;
